import { useState } from "react";
import * as api from "../../api/client";
import type { ApiCtx } from "../../api/client";
import type { SearchMatch } from "../../api/types";
import { useUi } from "../../state/ui";
import { texte } from "../../texte";

export function Search({ ctx }: { ctx: ApiCtx }) {
  const openFile = useUi((s) => s.openFile);
  const [pattern, setPattern] = useState("");
  const [matches, setMatches] = useState<SearchMatch[] | null>(null);
  const [count, setCount] = useState(0);
  const [docCount, setDocCount] = useState(0);

  async function runSearch() {
    const q = pattern.trim();
    if (!q) return;
    const res = await api.search(ctx, q);
    if (res.code < 0) return;
    setMatches(res.matches ?? []);
    setCount(res.count ?? res.matches?.length ?? 0);
    const filesRes = await api.files(ctx);
    setDocCount(filesRes.documents?.length ?? 0);
  }

  function highlight(text: string, q: string) {
    if (!q) return text;
    const idx = text.toLowerCase().indexOf(q.toLowerCase());
    if (idx === -1) return text;
    return (
      <>
        {text.slice(0, idx)}
        <mark>{text.slice(idx, idx + q.length)}</mark>
        {text.slice(idx + q.length)}
      </>
    );
  }

  return (
    <>
      <div className="search-row">
        <input
          type="text"
          value={pattern}
          placeholder={texte.search.placeholder}
          onChange={(e) => setPattern(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && runSearch()}
        />
        <button className="btn" onClick={runSearch}>
          {texte.search.button}
        </button>
      </div>
      {matches &&
        (matches.length ? (
          <>
            {matches.slice(0, 30).map((m, i) => (
              <div className="match" key={i}>
                <button className="d" title={texte.search.openInPane} onClick={() => openFile(m[0])}>
                  {m[0]}
                </button>
                <span className="l">{m[1]}</span>
                <span>{highlight(m[2], pattern)}</span>
              </div>
            ))}
            <p className="hint" style={{ marginTop: 12 }}>
              {texte.search.matchesIn(count, docCount)}
            </p>
          </>
        ) : (
          <div className="empty" style={{ maxWidth: 560 }}>
            {texte.search.noMatches} „{pattern}“.
          </div>
        ))}
    </>
  );
}
